import { render, staticRenderFns } from "./FoodService.vue?vue&type=template&id=07bcf346&scoped=true&"
import script from "./FoodService.vue?vue&type=script&lang=js&"
export * from "./FoodService.vue?vue&type=script&lang=js&"
import style0 from "./FoodService.vue?vue&type=style&index=0&id=07bcf346&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bcf346",
  null
  
)

export default component.exports